import Repository from "./Repository";

const ADD_ENTRY = "add";
const DELETE_ENTRY = "delete";
const UPDATE_ENTRY = "update";
const GET_ENTRY = "get";
const GET_BY_USER_ENTRY = "getByUser";

export default {
  getAllCollection() {
    return Repository.get(transformRoute(GET_ENTRY));
  },
  getOneCollectionByUser() {
    return Repository.get(transformRoute(GET_BY_USER_ENTRY));
  },
  addOneCollection(payload) {
    return Repository.post(transformRoute(ADD_ENTRY), payload);
  },
  editOneCollection(payload) {
    return Repository.post(transformRoute(UPDATE_ENTRY), payload);
  }, //remove this
  deleteOneCollection(payload) {
    return Repository.post(transformRoute(DELETE_ENTRY), payload);
  },
};

const transformRoute = (route) => {
  return `/address/${route}`;
};
